import gql from 'graphql-tag';
import CLASSROOM_FRAGMENT from 'graph/fragments/classroom';
import STUDENT_FRAGMENT from 'graph/fragments/student';
import STUDENT_LICENSE_USAGE_FRAGMENT from 'graph/fragments/student-license-usage';
import GROUPS_FRAGMENT from 'graph/fragments/groups';

const GET_CLASSROOM_LICENSES_STUDENTS = gql`
  query getClassroomLicenseUsage($classroomId: Int!) {
    classroom(where: { id: $classroomId }) {
      ...BaseClassroom
      students {
        ...BaseStudent
        licenseUsage {
          ...BaseStudentLicenseUsage
        }
        groups {
          ...BaseGroups
        }
      }
      organization {
        rootOrganization {
          licenseUsage {
            assignedCount
            availableCount
            siteLicensed
            totalCount
            overageStats {
              assignedCount
              availableCount
              overageLimitCount
              totalCount
            }
            product {
              id
              code
              name
              type
              family {
                id
                code
                name
              }
            }
            productCurriculum {
              id
              code
            }
          }
        }
      }
    }
  }
  ${CLASSROOM_FRAGMENT}
  ${STUDENT_FRAGMENT}
  ${STUDENT_LICENSE_USAGE_FRAGMENT}
  ${GROUPS_FRAGMENT}
`;

export default GET_CLASSROOM_LICENSES_STUDENTS;
